let themeInitialized = false;

export function themeColors(root = document) {
    const elements = root.querySelectorAll('[data-theme-color]');
    const rootStyles = getComputedStyle(document.documentElement);

    let currentColor = null;

    const getColor = (element) => {
        const theme = element.dataset?.themeColor?.trim();

        const variable = theme && theme !== 'none'
            ? `--color-background-${theme}`
            : '--color-background';

        return colorToRgba(
            rootStyles.getPropertyValue(variable).trim()
            || rootStyles.getPropertyValue('--color-background').trim()
        );
    };

    const setColor = (color, immediate = false) => {
        if (!color || color === currentColor) return;

        currentColor = color;

        gsap.killTweensOf(document.body, 'backgroundColor,--header-background-color');

        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            gsap.set(document.body, {
                backgroundColor: color,
                '--header-background-color': color
            });

            return;
        }

        gsap.to(document.body, {
            backgroundColor: color,
            '--header-background-color': color,
            duration: 0.5,
            ease: 'power1.inOut',
            overwrite: 'auto'
        });
    };

    const sections = Array.from(elements, (element) => ({
        element,
        color: getColor(element),
        trigger: null
    }));
    let ready = false;

    const updateColor = (immediate = false) => {
        if (!ready) return;

        // Use the same boundary in both directions, including gaps between sections.
        let color = sections[0]?.color || getColor(root);
        sections.forEach((section) => {
            if (section.trigger.scroll() >= section.trigger.start) {
                color = section.color;
            }
        });
        setColor(color, immediate);
    };

    sections.forEach((section) => {
        section.trigger = ScrollTrigger.create({
            trigger: section.element,
            start: 'top 50%',
            end: 'bottom 50%',
            onEnter: () => updateColor(),
            onEnterBack: () => updateColor(),
            onLeaveBack: () => updateColor(),
            onRefresh: () => updateColor()
        });
    });

    ready = true;
    // Only the initial document load sets the color immediately.
    updateColor(!themeInitialized);
    themeInitialized = true;
}

// Keep GSAP interpolation in RGB: an HSL endpoint makes it animate hue too.
export function colorToRgba(color) {
    if (!color) return color;

    const [red, green, blue, alpha = 1] = gsap.utils.splitColor(color);
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
